module.exports = __webpack_public_path__ + "static/media/smoothsole-5.3938d36c.jpg";